import { render } from "./BankingDashboard.vue?vue&type=template&id=10db64d6&scoped=true"
import script from "./BankingDashboard.vue?vue&type=script&lang=js"
export * from "./BankingDashboard.vue?vue&type=script&lang=js"

import "./BankingDashboard.vue?vue&type=style&index=0&id=10db64d6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10db64d6"]])

export default __exports__